import React from 'react';

import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid} from '@material-ui/core';

import {FieldShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {RealOwnerAdditionalInformation} from 'commons/models';
import {EfeButtonPrimary, EfeFormSection} from 'components';

InnerFormRepresentativeAdditional.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    filterTradedFields: PropTypes.func.isRequired,
};

function InnerFormRepresentativeAdditional(
    props: InferPropTypes<
        typeof InnerFormRepresentativeAdditional.propTypes &
            FormikProps<RealOwnerAdditionalInformation>
    >
) {
    const {values, errors, fields, isSubmitting, setFieldValue, filterTradedFields} = props;
    React.useEffect(() => {
        filterTradedFields(values.traded);
    }, [values.traded]);
    /* eslint-disable react/jsx-handler-names */
    return (
        <Form noValidate>
            {fields && fields.length > 0 && (
                <Box m={2}>
                    <EfeFormSection
                        fields={fields}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            )}
        </Form>
    );
}

export default InnerFormRepresentativeAdditional;
